

// export const SalonFilter = ({ isModalOpen, handleCancel }) => {
//   const handleOk = () => {
//     // setIsModalOpen(false);
//   };

//   const onChange = (value) => {
//     console.log(`selected ${value}`);
//   };
//   const onSearch = (value) => {
//     console.log("search:", value);
//   };

//   const disabledDate = (current) => {
//     return current && current > dayjs().endOf("day");
//   };

//   return (
//     <>
//       <Modal
//         title="Filters"
//         open={isModalOpen}
//         onOk={handleOk}
//         okText={"Filter Data"}
//         onCancel={handleCancel}
//       >
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             marginBottom: "20px",
//             marginTop:"20px"
//           }}
//         >
//           <Select
//             showSearch
//             placeholder="Select by Salon Name"
//             optionFilterProp="label"
//             onChange={onChange}
//             onSearch={onSearch}
//             style={{
//               width: 230,
//             }}
//             options={[
//               {
//                 value: "jack",
//                 label: "Jack",
//               },
//               {
//                 value: "lucy",
//                 label: "Lucy",
//               },
//               {
//                 value: "tom",
//                 label: "Tom",
//               },
//             ]}
//           />

//           <Select
//             showSearch
//             placeholder="Select by Owner Name"
//             optionFilterProp="label"
//             onChange={onChange}
//             onSearch={onSearch}
//             style={{
//               width: 230,
//             }}
//             options={[
//               {
//                 value: "jack",
//                 label: "Jack",
//               },
//               {
//                 value: "lucy",
//                 label: "Lucy",
//               },
//               {
//                 value: "tom",
//                 label: "Tom",
//               },
//             ]}
//           />
//           {/* <Select
//             showSearch
//             placeholder="Select by Email"
//             optionFilterProp="label"
//             onChange={onChange}
//             onSearch={onSearch}
//             style={{
//               width: 230,
//             }}
//             options={[
//               {
//                 value: "jack",
//                 label: "Jack",
//               },
//               {
//                 value: "lucy",
//                 label: "Lucy",
//               },
//               {
//                 value: "tom",
//                 label: "Tom",
//               },
//             ]}
//           /> */}
//         </div>
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             marginBottom: "20px",
//           }}
//         >
//           {/* <Select
//             showSearch
//             placeholder="Select by Mobile Number"
//             optionFilterProp="label"
//             onChange={onChange}
//             onSearch={onSearch}
//             style={{
//               width: 230,
//             }}
//             options={[
//               {
//                 value: "jack",
//                 label: "Jack",
//               },
//               {
//                 value: "lucy",
//                 label: "Lucy",
//               },
//               {
//                 value: "tom",
//                 label: "Tom",
//               },
//             ]}
//           /> */}
//           <Select
//             showSearch
//             placeholder="Select by Aadhar Number"
//             optionFilterProp="label"
//             onChange={onChange}
//             onSearch={onSearch}
//             style={{
//               width: 230,
//             }}
//             options={[
//               {
//                 value: "jack",
//                 label: "Jack",
//               },
//               {
//                 value: "lucy",
//                 label: "Lucy",
//               },
//               {
//                 value: "tom",
//                 label: "Tom",
//               },
//             ]}
//           />

//           <Select
//             showSearch
//             placeholder="Select by Salon Type"
//             optionFilterProp="label"
//             onChange={onChange}
//             onSearch={onSearch}
//             style={{
//               width: 230,
//             }}
//             options={[
//               {
//                 value: "jack",
//                 label: "Jack",
//               },
//               {
//                 value: "lucy",
//                 label: "Lucy",
//               },
//               {
//                 value: "tom",
//                 label: "Tom",
//               },
//             ]}
//           />
//         </div>
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             marginBottom: "20px",
//           }}
//         >
//           <Select
//             showSearch
//             placeholder="Select by Service Type"
//             optionFilterProp="label"
//             onChange={onChange}
//             onSearch={onSearch}
//             style={{
//               width: 230,
//             }}
//             options={[
//               {
//                 value: "jack",
//                 label: "Jack",
//               },
//               {
//                 value: "lucy",
//                 label: "Lucy",
//               },
//               {
//                 value: "tom",
//                 label: "Tom",
//               },
//             ]}
//           />
//           <Select
//             showSearch
//             placeholder="Select by Service KM"
//             optionFilterProp="label"
//             onChange={onChange}
//             onSearch={onSearch}
//             style={{
//               width: 230,
//             }}
//             options={[
//               {
//                 value: "jack",
//                 label: "Jack",
//               },
//               {
//                 value: "lucy",
//                 label: "Lucy",
//               },
//               {
//                 value: "tom",
//                 label: "Tom",
//               },
//             ]}
//           />

//           <Select
//             showSearch
//             placeholder="Select by Status"
//             optionFilterProp="label"
//             onChange={onChange}
//             onSearch={onSearch}
//             style={{
//               width: 230,
//             }}
//             options={[
//               {
//                 value: "jack",
//                 label: "Jack",
//               },
//               {
//                 value: "lucy",
//                 label: "Lucy",
//               },
//               {
//                 value: "tom",
//                 label: "Tom",
//               },
//             ]}
//           />
//         </div>
//         <div>
//           <Space direction="vertical" size={12} style={{marginBottom:"20px"}}>
//             <RangePicker disabledDate={disabledDate} />
//           </Space>
//         </div>
//       </Modal>
//     </>
//   );
// };


import React, { useEffect, useState } from "react";
import { Button, DatePicker, Modal, Select, Space, Input, Form } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Option } from "antd/es/mentions";
dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;

export const SalonFilter = ({ form, isModalOpen, handleCancel, setFilterForm, filterForm, handleFilter }) => {


  return (
    <>
      <Modal
        title="Filters"
        open={isModalOpen}
        onOk={handleFilter}
        okText={"Filter Data"}
        onCancel={handleCancel}
      >
        <Form form={form} layout="vertical" >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
              marginTop: "20px",
            }}
          >
            <Form.Item
              name="salonName"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter the salon name!" },
              ]}
            >
              <Input value={filterForm?.salonName} onChange={(e) => setFilterForm({ ...filterForm, salonName: e.target.value })} size="large" placeholder="filter by  salon name" />
            </Form.Item>

            <Form.Item
              name="salonType"
              className="subscription-plan"
            >
              <Select
                placeholder="filter by  salon type"
                value={filterForm?.salonType}
                onChange={(value) => setFilterForm({ ...filterForm, salonType: value })}
                style={{
                  marginTop: "0.5rem",
                  width: "99%",
                }}
              >
                <Option value="0">
                  Male
                </Option>
                <Option value="1">
                  Female
                </Option>
                <Option value="2">
                  Both
                </Option>
              </Select>
            </Form.Item>
        
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            {/* <Form.Item
              name="status"
              className="subscription-plan"
            >
              <Select
                value={filterForm?.status}
                onChange={(value) => setFilterForm({ ...filterForm, status: value })}
                placeholder="filter by status"
                style={{
                  marginTop: "0.5rem",
                  width: "99%",
                }}
                options={[
                  {
                    value: "0",
                    label: "InActive",
                  },
                  {
                    value: "1",
                    label: "Active",
                  },
                ]}
              />
            </Form.Item> */}

            <Form.Item
              name="serviceType"
              className="subscription-plan"
            >
              <Select
                placeholder="filter by  service type"
                value={filterForm?.serviceType}
                onChange={(value) => setFilterForm({ ...filterForm, serviceType: value })}
                style={{
                  marginTop: "0.5rem",
                  width: "99%",
                }}
              >
                <Option value="0">
                  Home
                </Option>
                <Option value="1">
                  Salon
                </Option>
                <Option value="2">
                  Both
                </Option>
              </Select>
            </Form.Item>
          </div>
          <div>
            <Space direction="vertical" size={12} style={{ marginBottom: "20px" }}>
              {/* <RangePicker disabledDate={disabledDate} /> */}
            </Space>
          </div>
        </Form>
      </Modal>
    </>
  );
};
